import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_RESETPASSWORDS = "resetpasswords";
const BASE_URL = "/api/resetpasswords";

const ResetPasswordsQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const RESETPASSWORD_EMPTY = {
    memberNumber: "",
    email: "",
    token: "",
    date: ""
};

export function useResetPasswords() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_RESETPASSWORDS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...ResetPasswordsQueryConfig
    });
    return {...result, resetPasswords: result.data};
}


export function useResetPassword(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_RESETPASSWORDS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...ResetPasswordsQueryConfig
    });
    return {...result, resetPassword: result.data};
}

export function useResetPasswordMutations() {
    async function createFunction(resetPassword) {
        if (!resetPassword) return;
        return await fetchPOST(BASE_URL, resetPassword, false);
    }
    async function resetPassword(object) {
        if (!object) return;
        return await fetchPOST(BASE_URL+"/resetpassword", object, false);
    }

    async function editFunction(resetPassword) {
        if (!resetPassword) return;
        return await fetchPUT(`${BASE_URL}/${resetPassword.id}`, resetPassword);
    }

    async function editAddNewFiles(resetPassword) {
        if (!resetPassword) return;
        return await fetchPUT(`${BASE_URL}/${resetPassword.id}/files`, resetPassword.fileId);
    }

    async function deleteFunction(resetPassword) {
        return await fetchDELETE(`${BASE_URL}/${resetPassword.id}`)
    }

    return {
        createResetPassword: useMyMutation(createFunction, REACT_QUERY_ID_RESETPASSWORDS, resetPassword => `ResetPassword ${resetPassword.title} created`),
        editResetPassword: useMyMutation(editFunction, REACT_QUERY_ID_RESETPASSWORDS, resetPassword => `ResetPassword ${resetPassword.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_RESETPASSWORDS, resetPassword => `ResetPassword ${resetPassword.title} modified`),
        deleteResetPassword: useMyMutation(deleteFunction, REACT_QUERY_ID_RESETPASSWORDS, resetPassword => `ResetPassword ${resetPassword.title} deleted.`),
        resetPassword: useMyMutation(resetPassword, REACT_QUERY_ID_RESETPASSWORDS, resetPassword => `ResetPassword ${resetPassword.title} reset.`)

    };

}